export default __webpack_public_path__ + "static/media/lack-of-bleeding-OFF.6d06b3eb.png";